'use strict';

var badge = require('../../../../../../../../../../_virtual/badge2.cjs');

(function (exports) {

	exports.BADGE_SIZES = void 0;
	(function(BADGE_SIZES) {
	    BADGE_SIZES["xsmall"] = "xsmall";
	    BADGE_SIZES["small"] = "small";
	    BADGE_SIZES["medium"] = "medium";
	})(exports.BADGE_SIZES || (exports.BADGE_SIZES = {}));
	
} (badge.__exports));
//# sourceMappingURL=badge.cjs.map
